import userTypes from '../constants/userTypes';
import axiosApi from '../../services/axiosApi';
import { userRoleTypes } from '../../config';
import { setCookie, removeCookie, getCookie } from '../../services/cookies';
import { fieldsValueArray } from './customFunction';
import moment from 'moment';

export const signin = (email, password, otp = false, hash = '') => {
  return async dispatch => {
    try {
      let client_side = 'client_side';
      let credentials = { email, password, client_side };
      if (otp) {
        credentials = { email, password, otp, hash, client_side };
      }
      let dataResponse = await axiosApi(process.env.apiURL + 'auth/login', 'post', credentials);
      let data = dataResponse.data;
      if (data) {
        let accessToken = data.access_token;
        let date = new Date();
        date.setTime(date.getTime() + data.expires);
        setCookie('ssfToken', accessToken, data.expires);
        setCookie('ssfTime', date.toUTCString(), data.expires);
        setCookie('ssfrft', data.refresh_token, data.expires);
        // ?access_token=' + accessToken
        let userResponse = await axiosApi(process.env.apiURL + 'users/me', 'get', null);
        let user = userResponse.data;
        let allPermissions = await tabPermissionsData();
        if (user) {
          let roleType = userRoleTypes[user.role].name;
          let userData = {
            user: user,
            accessToken: accessToken,
            roleType,
            tabs_access: allPermissions.tabs,
            tabs_permissions: allPermissions.tabs_permissions,
            prints_negatives_obj: allPermissions.prints_negatives_obj,
            collections_permissions: allPermissions.collections_permissions,
          };
          sessionStorage.setItem('userData', JSON.stringify(user));
          dispatch({ type: userTypes.LOGIN_SUCCESS, payload: userData });
          dispatch({
            type: userTypes.STATUS,
            payload: { type: 'success', message: 'logged in sucessfully!' },
          });
        }
      }
    } catch (error) {
      return Promise.reject(error);
    }
  };
};

export const manualSignIn = accessToken => {
  return async dispatch => {
    try {
      let userReponse, user;
      if (sessionStorage.getItem('userData') !== '' && sessionStorage.getItem('userData') !== null) {
        user = JSON.parse(sessionStorage.getItem('userData'));
      } else {
        userReponse = await axiosApi(process.env.apiURL + 'users/me', 'get', null);
        user = userReponse.data;
        sessionStorage.setItem('userData', JSON.stringify(user));
      }
      let allPermissions = await tabPermissionsData();
      if (user) {
        let roleType = userRoleTypes[user.role].name;
        let userData = {
          user: user,
          accessToken: accessToken,
          roleType,
          tabs_access: allPermissions.tabs,
          tabs_permissions: allPermissions.tabs_permissions,
          prints_negatives_obj: allPermissions.prints_negatives_obj,
          collections_permissions: allPermissions.collections_permissions,
        };
        dispatch({ type: userTypes.LOGIN_SUCCESS, payload: userData });
        dispatch({
          type: userTypes.STATUS,
          payload: { type: 'success', message: 'logged in sucessfully!' },
        });
      }
    } catch (error) {
      dispatch({
        type: userTypes.STATUS,
        payload: { type: 'failed', message: 'invalid username and password' },
      });
    }
  };
};

export const signOut = () => {
  return async dispatch => {
    try {
      let refresh_token = getCookie('ssfrft');
      await axiosApi(process.env.apiURL + 'auth/logout', 'post', {
        refresh_token: refresh_token,
      });
      await removeCookie('ssfToken');
      await removeCookie('ssfTime');
      await removeCookie('ssfrft');
      sessionStorage.removeItem('userData');
      dispatch({ type: userTypes.LOG_OUT });
    } catch (error) {
      console.log(error);
    }
  };
};

export const refreshtoken = token => {
  return async dispatch => {
    try {
      let refreshtoken = { refresh_token: token };
      let { data } = await axiosApi(process.env.apiURL + 'auth/refresh', 'post', refreshtoken);

      if (data) {
        let accessToken = data.access_token;
        setCookie('ssfToken', accessToken, data.expires);
        let date = new Date();
        date.setTime(date.getTime() + data.expires);
        setCookie('ssfTime', date.toUTCString(), data.expires);
        setCookie('ssfrft', data.refresh_token, data.expires);

        let userReponse = await axiosApi(process.env.apiURL + 'users/me', 'get', null);
        let user = userReponse.data;
        if (user) {
          sessionStorage.setItem('userData', JSON.stringify(user));
          let userData = {
            user: user,
            accessToken: accessToken,
          };

          dispatch({ type: userTypes.LOGIN_SUCCESS, payload: userData });
          dispatch({
            type: userTypes.STATUS,
            payload: { type: 'success', message: 'logged in sucessfully!' },
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
};

export const passwordReset = email => {
  return async dispatch => {
    try {
      let data = { email, reset_url: process.env.reset_url };
      return await axiosApi(process.env.apiURL + 'auth/password/request', 'post', data);
    } catch (error) {
      console.log('reset error ', error);
    }
  };
};
export const resetPassword = (token, password) => {
  return async dispatch => {
    try {
      let data = { token, password };
      return await axiosApi(process.env.apiURL + 'auth/password/reset', 'post', data);
    } catch (error) {
      return Promise.reject(error);
    }
  };
};

export const getItem = (collection, id, data = null) => {
  return async dispatch => {
    try {
      return await axiosApi(process.env.apiURL + 'items/' + collection + '/' + id, 'get', data);
    } catch (error) {
      return Promise.reject(error);
    }
  };
};

export const saveItem = (collection, data) => {
  return async dispatch => {
    try {
      let trimmedValues = {};
      for (const key in data) {
        trimmedValues[key] = typeof data[key] === 'string' ? data[key].trim() : data[key];
      }
      if (data.id) {
        return await axiosApi(process.env.apiURL + 'items/' + collection + '/' + data.id, 'PATCH', trimmedValues);
      }
      return await axiosApi(process.env.apiURL + 'items/' + collection, 'post', trimmedValues);
    } catch (error) {
      return Promise.reject(error);
    }
  };
};

export const getItems = (collection, params) => {
  return async (dispatch, getState) => {
    try {
      let fields = params.fields;
      let sort = params.sort;
      let meta = params.meta;
      let filters = params?.filters || {};
      let offset = params.offset;
      let limit = params.limit;
      let tt = params?.tt;
      let {
        user: {
          collections_permissions,
          roleType,
          user: { id },
        },
      } = getState();
      if (roleType !== 'admin') {
        if (collection === 'collections') {
          filters['user_permission'] = {
            _and: [{ view: { _eq: true } }, { user: { id: { _eq: id } } }],
          };
        }
        if (collection === 'location') {
          let updatedFilter = { ...filters };
          delete filters.collections;
          updatedFilter?.collections
            ? (filters['_and'] = [{ collections: { _in: collections_permissions.view } }, { collections: updatedFilter.collections }])
            : (filters['collections'] = { _in: collections_permissions.view });
        }
      }

      let data = {
        fields: fields,
        sort: sort,
        meta: meta,
        filter: filters,
        offset: offset,
        limit: limit,
        ...tt,
      };
      return await axiosApi(process.env.apiURL + 'items/' + collection, 'GET', data);
    } catch (error) {
      return Promise.reject(error);
    }
  };
};
// Book illustrations with numeric plate sort via custom endpoint
export const getBookIllustrations = params => {
  return async () => {
    try {
      const query = {
        limit:  params.limit,
        offset: params.offset,
        sort:   params.sort,
        meta:   params.meta,
      };
      if (params.fields) query.fields = Array.isArray(params.fields) ? params.fields.join(',') : params.fields;
      if (params.filters && Object.keys(params.filters).length) query.filters = JSON.stringify(params.filters);
      return await axiosApi(process.env.apiURL + 'book-illustration/list', 'GET', query);
    } catch (error) {
      return Promise.reject(error);
    }
  };
};

//get user's from directus backend by REST API Call "/users"
export const getUsersData = (collection, params) => {
  return async dispatch => {
    try {
      let fields = params.fields;
      let sort = params.sort;
      let meta = params.meta;
      let filters = params.filters;
      let offset = params.offset;
      let limit = params.limit;
      let data = {
        fields: fields,
        sort: sort,
        meta: meta,
        filter: filters,
        offset: offset,
        limit: limit,
      };
      return await axiosApi(process.env.apiURL + collection, 'GET', data);
    } catch (error) {
      return Promise.reject(error);
    }
  };
};

//get user by id from directus backend by REST API Call "/users/:id"
export const getUserData = (collection, params) => {
  return async dispatch => {
    try {
      let fields = params.fields;
      let sort = params.sort;
      let meta = params.meta;
      let filters = params.filters;
      let offset = params.offset;
      let limit = params.limit;
      let data = {
        fields: fields,
        sort: sort,
        meta: meta,
        filter: filters,
        offset: offset,
        limit: limit,
      };
      return await axiosApi(process.env.apiURL + collection + '/' + params.id, 'GET', data);
    } catch (error) {
      return Promise.reject(error);
    }
  };
};

//save user data to directus database
export const saveUserData = (collection, item, id) => {
  return async dispatch => {
    try {
      let trimmedValues = {};
      for (const key in item) {
        trimmedValues[key] = typeof item[key] === 'string' ? item[key].trim() : item[key];
      }
      return id
        ? await axiosApi(process.env.apiURL + collection + '/' + id, 'patch', trimmedValues)
        : await axiosApi(process.env.apiURL + collection, 'post', trimmedValues);
    } catch (error) {
      console.log('error ', error);
      return Promise.reject(error);
    }
  };
};

export const deleteItem = (collection, id) => {
  return async dispatch => {
    try {
      const response = await axiosApi(process.env.apiURL + 'items/' + collection + '/' + id, 'DELETE');
      return response;
    } catch (err) {
      console.log(err, 'delete error');
      return Promise.reject(err);
    }
  };
};

export const deleteUser = (collection, id) => {
  return async dispatch => {
    try {
      const response = await axiosApi(process.env.apiURL + collection + '/' + id, 'DELETE');
      return response;
    } catch (err) {
      console.log(err, 'delete error');
      return Promise.reject(err);
    }
  };
};
export const collectionObject = (data, type = null, id = null) => {
  return async dispatch => {
    let headers = {
      'Content-Type': 'multipart/form-data',
    };
    try {
      if (id) {
        return await axiosApi(process.env.apiURL + type + '/' + id, 'patch', data, headers);
      }
      return await axiosApi(process.env.apiURL + type, 'post', data, headers);
    } catch (error) {
      console.log(error, 'error');
      return Promise.reject(error);
    }
  };
};
//Delete  collections object and its file
export const deleteCollectionObj = (collection, id) => {
  return async dispatch => {
    try {
      const response = await axiosApi(process.env.apiURL + 'file/object/' + collection + '/' + id, 'delete');
      return response;
    } catch (err) {
      console.log(err, 'delete error');
    }
  };
};
//xrf
export const saveFileItem = (collection, data, id = null, recordExist = null) => {
  return async dispatch => {
    let headers = {
      'Content-Type': 'multipart/form-data',
    };
    try {
      if (!!recordExist) {
        return await axiosApi(process.env.apiURL + collection + '/' + recordExist.id, 'patch', data, headers);
      }
      return await axiosApi(process.env.apiURL + collection + '/' + id, 'post', data, headers);
    } catch (error) {
      console.log(error, 'xrf error');
      return Promise.reject(error);
    }
  };
};

export const fetchFieldValues = (collection, fieldname) => {
  return async dispatch => {
    try {
      const url = `${process.env.apiURL}fields/${collection}/${fieldname.fields}`;
      return await axiosApi(url, 'get');
    } catch (error) {
      console.log(error, 'errorerrorerrorfetchPossibleValues');
    }
  };
};
export const fetchMultipleFieldValues = collection => {
  return async dispatch => {
    try {
      const url = `${process.env.apiURL}fields/${collection}`;
      return await axiosApi(url, 'get');
    } catch (error) {
      console.log(error, 'errorerrorerrorfetchPossibleValues');
    }
  };
};

export const negativeFilter = data => {
  return async dispatch => {
    try {
      return await axiosApi(`${process.env.apiURL}negative-filter`, 'POST', data);
    } catch (error) {
      console.log(error, 'errorerrorerrorfetchPossibleValues');
    }
  };
};
export const getImageDescription = (object_id, supData, negative_id = null) => {
  return async dispatch => {
    try {
      let filters = !!negative_id
        ? {
            _and: [
              { related_object: { _neq: object_id } },
              {
                negative: {
                  _eq: negative_id,
                },
              },
            ],
          }
        : { related_object: { _eq: object_id } };
      let dataFilter = {
        fields: [
          'id,related_object,geographic_location.id,geographic_location.geographic_locations_id.id,geographic_location.geographic_locations_id.park,negative,image_description,specific_sub,depicted_loc,support_table_data.id,support_table_data.support_table_id.id,support_table_data.support_table_id.fields',
        ],
        filter: filters,
      };
      let { data } = await axiosApi(process.env.apiURL + 'items/image_description', 'GET', dataFilter);
      data = data.map(item => {
        return {
          ...item,
          subject_general: fieldsValueArray(item.support_table_data, 'subject_general', supData),
          sub_gen_landscape: fieldsValueArray(item.support_table_data, 'subject_general_landscape', supData),
          season: fieldsValueArray(item.support_table_data, 'season', supData),
          flora: fieldsValueArray(item.support_table_data, 'flora', supData),
          landforms: fieldsValueArray(item.support_table_data, 'landforms', supData),
          atmospheric: fieldsValueArray(item.support_table_data, 'atmospheric', supData),
          transportation: fieldsValueArray(item.support_table_data, 'env_transportation', supData),
          env_structures: fieldsValueArray(item.support_table_data, 'env_structure', supData),
          site: fieldsValueArray(item.support_table_data, 'env_site', supData),
          human_and_animals: fieldsValueArray(item.support_table_data, 'human_and_animals', supData),
          bodies_of_water: fieldsValueArray(item.support_table_data, 'bodies_of_water', supData),
          support_table_data: fieldsValueArray(item.support_table_data, 'support_table_data', supData),
          geographic_location: item.geographic_location.map(obj => obj.geographic_locations_id.id),
          image_description_geographic_locations: item.geographic_location.map(obj => obj.id),
          park: item.geographic_location.length > 0 ? item.geographic_location[0].geographic_locations_id.park : '',
          img_sup_data: item.support_table_data,
        };
      });
      return data.length > 0 ? data[0] : '';
    } catch (error) {
      console.log(error, 'errorerrorerrorfetchPossibleValues');
    }
  };
};

export const getFile = fileID => {
  return async dispatch => {
    try {
      let options = {
        responseType: 'arraybuffer',
      };
      // ?width=100&height=100&fit=contain&quality=75
      let res = await axiosApi(
        `${process.env.apiURL}assets/${fileID}?width=300&fit=contain&quality=100&cache=${Date.now()}`,
        'GET',
        null,
        null,
        options
      );
      return res;
    } catch (error) {
      console.log(error, 'errorerrorerrorfetchPossibleValues');
    }
  };
};
export const getPdfFile = (fileID, name) => {
  return async dispatch => {
    try {
      let options = {
        responseType: 'blob',
      };
      let report = await axiosApi(`${process.env.apiURL}assets/${fileID}`, 'GET', null, null, options);
      if (report) {
        const url = window.URL.createObjectURL(new Blob([report]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', name);
        document.body.appendChild(link);
        link.click();
      }
    } catch (error) {
      console.log(error, 'errorerrorerrorfetchPossibleValues');
    }
  };
};
export const saveFile = (data, id = null) => {
  return async dispatch => {
    let headers = {
      'Content-Type': 'multipart/form-data',
    };
    try {
      if (id) {
        return await axiosApi(process.env.apiURL + 'files/' + id, 'PATCH', data, headers);
      }
      return await axiosApi(process.env.apiURL + 'files', 'post', data, headers);
    } catch (error) {
      console.log(error, 'error');
      return Promise.reject(error);
    }
  };
};
export const createFolder = data => {
  return async dispatch => {
    try {
      return await axiosApi(process.env.apiURL + 'folders', 'post', data);
    } catch (error) {
      console.log(error, 'error');
      return Promise.reject(error);
    }
  };
};
export const Report = (collection, id = null, collectionID = null) => {
  return async dispatch => {
    let report = '';
    try {
      let options = {
        responseType: 'blob',
      };
      if (!!id) {
        report = await axiosApi(process.env.apiURL + 'reports/' + collection + '/' + id, 'GET', null, null, options);
      } else if (!!collectionID) {
        report = await axiosApi(process.env.apiURL + 'reports/collection/' + collection + '/' + collectionID, 'GET', null, null, options);
      } else {
        report = await axiosApi(process.env.apiURL + 'reports/' + collection, 'GET', null, null, options);
      }
      if (report) {
        const todayDateTime = moment().format('MM-DD-YYYY HH:mm:ss');

        const url = window.URL.createObjectURL(new Blob([report]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `report_${todayDateTime}.pdf`);
        document.body.appendChild(link);
        link.click();
      }
    } catch (error) {
      console.log(error, 'error');
      return Promise.reject(error);
    }
  };
};
export const basicReport = (data = null, reportType) => {
  return async dispatch => {
    let options = {
      // responseType: 'blob',
    };
    try {
      await axiosApi(process.env.apiURL + 'reports/basic-details-report/' + reportType, 'post', data, null, options);
      // if (report) {
      // const todayDateTime = moment().format('MM-DD-YYYY-HH-mm-ss');
      // const url = window.URL.createObjectURL(new Blob([report]));
      // const link = document.createElement('a');
      // const reportName = reportType !== 'catalog-report' ? 'overview-report' : reportType;
      // link.href = url;
      // link.setAttribute('download', `object-${reportName}-${todayDateTime}.pdf`);
      // document.body.appendChild(link);
      // link.click();
      // }
    } catch (error) {
      console.log(error, 'error');
      return Promise.reject(error);
    }
  };
};
export const collectionsPermissions = data => {
  return async dispatch => {
    try {
      return await axiosApi(`${process.env.apiURL}collections_permissions/${data}`, 'GET', null);
    } catch (error) {
      console.log(error, 'errorerrorerrorfetchPossibleValues');
    }
  };
};
export const saveBatchPermissions = (data, actualData, userID) => {
  return async dispatch => {
    try {
      let permission_data_1 = data.slice(1, -2);
      let permission_data_2 = actualData.slice(1, -2);
      const differentEntriesData = permission_data_1.filter(item_1 => {
        return !permission_data_2.some(
          item_2 =>
            item_2.all == item_1.all &&
            item_2.view == item_1.view &&
            item_2.edit == item_1.edit &&
            item_2.negatives_views == item_1.negatives_views &&
            item_2.prints_views == item_1.prints_views &&
            item_2.negatives_edit == item_1.negatives_edit &&
            item_2.prints_edit == item_1.prints_edit
        );
      });
      return await axiosApi(process.env.apiURL + 'collections_permissions/' + userID, 'post', differentEntriesData);
    } catch (error) {
      return Promise.reject(error);
    }
  };
};
export const getRolesPermissions = roleID => {
  return async dispatch => {
    try {
      return await axiosApi(`${process.env.apiURL}roles_permissions/${roleID}`, 'GET', null);
    } catch (error) {
      console.log(error, 'errorerrorerrorfetchPossibleValues');
    }
  };
};
//for roles_permissions
export const saveBatchRolesPermissions = (roleID, actualData, newData, saveForUsers) => {
  return async dispatch => {
    try {
      let update = false;
      actualData.filter(element => {
        if (update) {
          return false;
        }
        if (!!element.id) {
          update = true;
        }
      });
      newData = newData.map(obj => {
        return {
          ...obj,
          save_for_users: saveForUsers,
        };
      });
      const updateData = newData.filter(
        item_1 =>
          item_1.id === false ||
          !actualData.some(
            item_2 =>
              item_2.id !== false &&
              item_2.id == item_1.id &&
              item_2.all == item_1.all &&
              item_2.view == item_1.view &&
              item_2.edit == item_1.edit &&
              item_2.create == item_1.create &&
              item_2.delete == item_1.delete
          )
      );
      let data = {
        data: !!update ? updateData : newData,
      };
      if (!!update) {
        return await axiosApi(process.env.apiURL + 'roles_permissions/' + roleID, 'PATCH', data);
      }
      return await axiosApi(process.env.apiURL + 'roles_permissions/' + roleID, 'post', data);
    } catch (error) {
      return Promise.reject(error);
    }
  };
};
// Batch update
export const saveBatchItems = (collection, data) => {
  return async dispatch => {
    try {
      return await axiosApi(process.env.apiURL + 'items/' + collection, 'PATCH', data);
    } catch (error) {
      return Promise.reject(error);
    }
  };
};
//
const tabPermissionsData = async () => {
  let { data } = await axiosApi(process.env.apiURL + 'get_permissions', 'get', null);
  const settings = [];
  const bibliography = [];
  const tabs = data[0].tabs
    .map(element => {
      if (element.includes('settings')) {
        settings.push(element.replace('settings_', '').replace(/_/g, '-'));
        return null;
      }
      if (element.includes('bibliography')) {
        bibliography.push(element.replace('bibliography_', '').replace(/_/g, '-'));
        return null;
      }
      if (element == 'prints') {
        element = 'print-objects';
      }
      return element.replaceAll('_', '-');
    })
    .filter(Boolean);
  tabs.unshift('dashboard');
  settings.length > 0 && settings.unshift('settings');
  bibliography.length > 0 && bibliography.unshift('bibliography');
  if (!!tabs.includes('negatives')) {
    tabs.push('negative-req', 'negative-objects');
  }
  return {
    tabs: [...tabs, ...settings, ...bibliography],
    tabs_permissions: data[0].tabs_permissions,
    collections_permissions: data[0].collections_permissions,
    prints_negatives_obj: data[0].collection_obj,
  };
};
//generate data report
export const dataReport = (params, csv_download = false) => {
  return async dispatch => {
    try {
      let data = {
        data_report: params?.data_report ?? 'xrf_basic_details',
        sort: params?.sort,
        meta: params?.meta,
        filter: params?.filters,
        offset: params?.offset,
        limit: params?.limit,
      };
      if (!!csv_download) {
        let options = {
          responseType: 'blob',
        };
        const todayDateTime = moment().format('MM-DD-YYYY-HH-mm-ss');
        const report = await axiosApi(process.env.apiURL + 'data-reports/csv-download', 'GET', data, null, options);
        const url = window.URL.createObjectURL(new Blob([report]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${data.data_report}_data_report_${todayDateTime}.csv`);
        document.body.appendChild(link);
        link.click();
      } else {
        return await axiosApi(process.env.apiURL + 'data-reports', 'GET', data);
      }
    } catch (error) {
      console.log(error, 'error');
      return Promise.reject(error);
    }
  };
};

export const analysisReport = (data = null) => {
  return async dispatch => {
    let options = {
      responseType: 'blob',
    };
    try {
      const report = await axiosApi(process.env.apiURL + 'analysis-reports', 'post', data, null, options);
      if (report) {
        const todayDateTime = moment().format('MM-DD-YYYY-HH-mm-ss');
        const name = report.type === 'application/zip' ? `report_${todayDateTime}.zip` : `${data.analysis_category}_${todayDateTime}.pdf`;
        const url = window.URL.createObjectURL(new Blob([report]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', name);
        document.body.appendChild(link);
        link.click();
      }
    } catch (error) {
      console.log(error, 'error');
      return Promise.reject(error);
    }
  };
};

export const updatePermissionData = newID => {
  return async (dispatch, getState) => {
    let { user } = getState();
    if (user.roleType !== 'admin') {
      try {
        let userData = { ...user, ...user.prints_negatives_obj.push(newID) };
        dispatch({ type: userTypes.PERMISSION_GRANTED, payload: userData });
      } catch (error) {
        dispatch({
          type: userTypes.STATUS,
          payload: { type: 'failed', message: 'failed to update permission' },
        });
      }
    }
  };
};
// export const s3UploadFile = (data, id = null) => {
//   return async dispatch => {
//     let headers = {
//       'Content-Type': 'multipart/form-data',
//     };
//     try {
//       if (id) {
//         return await axiosApi(process.env.apiURL + 's3_bucket_aws/upload-files' + id, 'PATCH', data, headers);
//       }
//       return await axiosApi(process.env.apiURL + 's3_bucket_aws/upload-files', 'post', data, headers);
//     } catch (error) {
//       console.log(error, 'error');
//       return Promise.reject(error);
//     }
//   };
// };
// export const s3GetFile = key => {
//   return async dispatch => {
//     let options = {
//       responseType: 'arraybuffer',
//     };
//     const parts = key.split('/');
//     // Extract the folder and the key (filename)
//     const folder = parts.slice(0, -1).join('/'); // Join all parts except the last one
//     const filename = parts[parts.length - 1]; // Get the last part
//     try {
//       return await axiosApi(
//         process.env.apiURL + 's3_bucket_aws/get-s3-files/' + folder + '/' + filename,
//         'GET',
//         null,
//         null,
//         null
//         // headers,
//         // options
//       );
//     } catch (error) {
//       console.log(error, 'error');
//       return Promise.reject(error);
//     }
//   };
// };

//this function is only for testing

export const advancedNegativeFilter = (data, type) => {
  return async dispatch => {
    try {
      return await axiosApi(`${process.env.apiURL}negative-filter/advanced-negative-filter/${type}`, 'GET', data);
    } catch (error) {
      console.log(error, 'errorerrorerrorfetchPossibleValues');
      return Promise.reject(error);
    }
  };
};

export const analyticalReports = (data = null, reportType = 'generate-images-report') => {
  return async dispatch => {
    let options = {
      // responseType: 'blob',
    };
    try {
      await axiosApi(process.env.apiURL + 'analytical-reports/' + reportType, 'post', data, null, options);
    } catch (error) {
      console.log(error, 'error');
      return Promise.reject(error);
    }
  };
};

export const reportByObj = (data, isCsv = false) => {
  return async dispatch => {
    try {
      if (isCsv) {
        let options = {
          responseType: 'blob',
        };
        const todayDateTime = moment().format('MM-DD-YYYY-HH-mm-ss');
        const response = await axiosApi(process.env.apiURL + 'report-by-object/download-csv', 'GET', data, null, options);

        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `print_objects_export_${todayDateTime}.csv`);
        document.body.appendChild(link);
        link.click();
      }
      return await axiosApi(`${process.env.apiURL}report-by-object/`, 'GET', data);
    } catch (error) {
      return Promise.reject(error);
    }
  };
};

//bibliography reports

// export const BibliographyPdfReport = () => {
//   return async dispatch => {
//     let report = '';
//     try {
//       let options = {
//         responseType: 'blob',
//       };

//       report = await axiosApi(process.env.apiURL + 'bibliography-reports/bb', 'GET', null, null, options);

//       if (report) {
//         const todayDateTime = moment().format('MM-DD-YYYY HH:mm:ss');
//         const url = window.URL.createObjectURL(new Blob([report]));
//         const link = document.createElement('a');
//         link.href = url;
//         link.setAttribute('download', `bibliographyreport_${todayDateTime}.pdf`);
//         document.body.appendChild(link);
//         link.click();
//       }
//     } catch (error) {
//       console.log(error, 'error');
//       return Promise.reject(error);
//     }
//   };
// };

// export const BibliographyPdfReport = () => {
//   return async dispatch => {
//     try {
//       const report = await axiosApi(process.env.apiURL + 'bibliography-reports/bb', 'post', null, null, { responseType: 'blob' });
//       if (report) {
//         const url = window.URL.createObjectURL(new Blob([report]));
//         const link = document.createElement('a');
//         link.href = url;
//         link.setAttribute('download', 't.pdf');
//         document.body.appendChild(link);
//         link.click();
//       }
//     } catch (error) {
//       console.error('PDF download failed:', error);
//       return Promise.reject(error);
//     }
//   };
// };

export const BibliographyPdfReport = payload => {
  return async dispatch => {
    try {
      const response = await axiosApi(process.env.apiURL + 'bibliography-reports/biblio-report', 'post', payload, null, null);
      return response;
    } catch (error) {
      console.error('Bibliography PDF report queue failed:', error);
      return Promise.reject(error);
    }
  };
};

export const earliestIllustrations = (params = null) => {
  return async dispatch => {
    try {
      const response = await axiosApi(process.env.apiURL + 'bibliography-reports/published-images', 'GET', params, null, null);
      return response;
    } catch (error) {
      console.log(error, 'earliest illustration error');
      return Promise.reject(error);
    }
  };
};

export const BibliographyBooksReport = (payload = null) => {
  return async dispatch => {
    try {
      const response = await axiosApi(process.env.apiURL + 'bibliography-reports/books-list-report', 'post', payload, null, null);
      return response;
    } catch (error) {
      console.error('Bibliography books report queue failed:', error);
      return Promise.reject(error);
    }
  };
};

export const PublishedImagePdfReport = (payload = null) => {
  return async dispatch => {
    try {
      const response = await axiosApi(process.env.apiURL + 'bibliography-reports/published-images-pdf', 'post', payload, null, null);
      return response;
    } catch (error) {
      console.error('Published images PDF report queue failed:', error);
      return Promise.reject(error);
    }
  };
};
